<!-- Catalogue -->
@let hasScrolledToMarsFooter = hasScrolledToMarsFooter$ | async;
@let showAppFooter = showAppFooter$ | async;

<div
  class="page-wrapper"
  [ngClass]="{
    'page-wrapper--withAside': withAside,
    'page-wrapper--withLeftPanel': withLeftPanel.show,
    'page-wrapper--withRightPanel': withRightPanel.show,
    'page-wrapper--withLeftPanelOpened': withLeftPanel.show && leftPanelOpened(),
    'page-wrapper--withRightPanelOpened': withRightPanel.show && rightPanelOpened(),
    'page-wrapper--withFooterMargin': withFooterMargin,
    'page-wrapper--medium': size === contentWrapperSizes.MEDIUM,
    'page-wrapper--large': size === contentWrapperSizes.LARGE,
    'page-wrapper--withMarsFooter': hasScrolledToMarsFooter,
    'page-wrapper--withMarsAndAppFooter': hasScrolledToMarsFooter && showAppFooter,
    'page-wrapper--standalone': isStandalone,
    'page-wrapper--with-legacy-progress-bar': withLegacyProgressBar,
  }"
>
  @if (withLeftPanel.show) {
    <div class="page-wrapper__left-panel" [class.page-wrapper__left-panel--with-legacy-progress-bar]="withLegacyProgressBar">
      <div class="wrapper">
        @if (!withLeftPanel.alwaysOpened) {
          <button class="rc-ui-button header" (click)="onToggleLeftPanel()">
            <app-icon class="page-wrapper__toggle-logo" [name]="iconNames.chevron_down"></app-icon>
            <p
              class="rc-ui-button__title rc-ui-button__title--link label"
              [ngClass]="{
                'label--verticalTopToBottomLanguage': isVerticalTopToBottomLanguage$ | async,
              }"
            >
              {{ leftPanelLabel }}
            </p>
          </button>
        }
        <div class="page-wrapper__left-panel__content">
          <ng-content select="[page-left-panel-content]"></ng-content>
        </div>
      </div>
    </div>
  }

  @if (withRightPanel.show) {
    <div class="page-wrapper__right-panel" [class.page-wrapper__right-panel--with-legacy-progress-bar]="withLegacyProgressBar">
      @if (!withRightPanel.alwaysOpened) {
        <div class="right-panel-toggle">
          <button class="rc-ui-button header" (click)="onToggleRightPanel()">
            <app-icon class="page-wrapper__toggle-logo" [name]="iconNames.chevron_down"></app-icon>
            <p class="label" [ngClass]="{ 'label--verticalTopToBottomLanguage': isVerticalTopToBottomLanguage$ | async }">
              {{ rightPanelLabel }}
            </p>
          </button>
        </div>
      }
      <div class="wrapper">
        <div class="page-wrapper__right-panel__content">
          <ng-content select="[page-right-panel-content]"></ng-content>
        </div>
      </div>
    </div>
  }

  <!-- ------------------------------------------------------------------
    Div use for animation,
    _
    The page-wrapper__panel block is fixed so we need a relative width div
    to work for the flex flow and animation width.
    ------------------------------------------------------------------- -->
  @if (withLeftPanel.show || withRightPanel.show) {
    <div class="panel-animation__block"></div>
  }

  @let stepperItems = stepperItems$ | async;
  <div class="page-wrapper__content" [class.page-wrapper__content--fullWidth]="fullWidth">
    @if (stepperItems?.length) {
      <app-stepper [items]="stepperItems" class="stepper"></app-stepper>
    }
    <div class="page-wrapper__content-inner" [ngClass]="{ 'page-wrapper__content-inner--withAppFooter': showAppFooter }">
      @if (withAside) {
        <ng-content select="[page-aside]"></ng-content>
      }
      <ng-content select="[page-content]"></ng-content>
    </div>
  </div>

  <div
    class="page-wrapper__footer"
    [ngClass]="{
      'page-wrapper__footer--withLeftPanel': withLeftPanel.show,
      'page-wrapper__footer--withRightPanel': withRightPanel.show,
      'page-wrapper__footer--withLeftPanelOpened': withLeftPanel.show && leftPanelOpened(),
      'page-wrapper__footer--withRightPanelOpened': withRightPanel.show && rightPanelOpened(),
      'page-wrapper__footer--withMarsFooter': hasScrolledToMarsFooter,
      'page-wrapper__footer--withLeftPanelAndMarsFooter': hasScrolledToMarsFooter && withLeftPanel.show,
      'page-wrapper__footer--withRightPanelAndMarsFooter': hasScrolledToMarsFooter && withRightPanel.show,
      'page-wrapper__footer--withLeftPanelOpenedAndMarsFooter': hasScrolledToMarsFooter && withLeftPanel.show && leftPanelOpened(),
      'page-wrapper__footer--withRightPanelOpenedAndMarsFooter': hasScrolledToMarsFooter && withRightPanel.show && rightPanelOpened(),
    }"
  >
    <ng-content select="[page-footer-content]"></ng-content>
  </div>
</div>
